<div class="row column--12 mt--md">
  <div class="subscription-section row column--12" [ngClass]="getSubscriptionStatusClass(subscription)">
    <div class="row column-lg--8 column--md-12 display-inline-flex row--valign-center">
      <div class="subscription-icon mr--sm" [ngClass]="getSubscriptionStatusIcon(subscription)"></div>
      <label>
        <ng-container [ngSwitch]="subscription">
          <div *ngSwitchCase="SubscriptionFinalStatus.NotSubscribed">
            {{ 'App.Subscription.Labels.NotSubscribed' | translate }}
          </div>
          <div *ngSwitchCase="SubscriptionFinalStatus.Expired">
            {{
              subscriptionEndDate
                ? ('App.Subscription.Labels.Expired' | translate) + (subscriptionEndDate | customFormat : TableDataType.StringDate)
                : ('App.Subscription.Labels.ExpiredNoDate' | translate)
            }}
          </div>
          <div *ngSwitchCase="SubscriptionFinalStatus.Overdue">
            {{ 'App.Subscription.Labels.Overdue' | translate }} {{ subscriptionEndDate | customFormat : TableDataType.StringDate }}
          </div>
          <div *ngSwitchCase="SubscriptionFinalStatus.PayPerUse">
            {{ 'App.Subscription.Labels.PayPerUse' | translate }}
          </div>
          <div *ngSwitchCase="SubscriptionFinalStatus.Active">
            {{ 'App.Subscription.Labels.Subscribed' | translate }} {{ subscriptionEndDate | customFormat : TableDataType.StringDate }}
          </div>
        </ng-container>
      </label>
    </div>
    @if(showHistoryPayment){
    <div>
      <button
        mat-button
        class="rounded"
        [ngClass]="getSubscriptionStatusButton(subscription)"
        (click)="onPaymentHistory.emit()"
      >
        <span>{{ 'App.Subscription.Buttons.PaymentHistory' | translate }}</span>
      </button>
    </div>
    }
  </div>
</div>
